import { Hole, SceneObjects } from '@types'

export default function isHole(hole?: SceneObjects): hole is Hole {
  return !!hole && hole?.type === 'holes'
}
